const getters = {
	myWebSocket(state) { // webSocket连接对象
		return state.myWebSocket;
	},
	timerMyWebSocketTimeOut(state) { // 连接超时timer
		return state.timerMyWebSocketTimeOut;
	},
	timerMyWebSocketHeart(state) { // 心跳包timer
		return state.timerMyWebSocketHeart;
	},
	timerMyWebSocketTimeInter(state) {
		return state.timerMyWebSocketTimeInter;
	}
};

export default getters;
